import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CommonMixin from "@/core/plugins/common-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { POST, GET } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin"; //import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";

import PhoneTextField from "@/view/pages/partials/PhoneTextField";
export default {
  mixins: [CommonMixin, ValidationMixin, FileManagerMixin],
  name: "user-create",
  data: function data() {
    return {
      roles: [],
      updateUser: {
        role: null,
        title: null,
        first_name: null,
        last_name: null,
        display_name: null,
        profile_logo: null
      },
      imageTemplate: false,
      imageLoading: false,
      fieldDescriptions: [{
        field: "product_type",
        title: "Product Type",
        description: "Select if this item is a physical good or a service you're offering.",
        footer: "Note",
        footer_content: "Once you include this items in a transaction, you cannot change its type."
      }]
    };
  },
  components: {
    PhoneTextField: PhoneTextField,
    CreateUpdateTemplate: CreateUpdateTemplate
  },
  methods: {
    selectImage: function selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },
    updateProfileImage: function updateProfileImage(param) {
      var _this = this;

      _this.imageLoading = true;

      _this.uploadAttachment(param).then(function (response) {
        _this.updateUser.profile_logo = _this.lodash.head(response);
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.imageLoading = false;
      });
    },
    getRoles: function getRoles() {
      var _this = this;

      _this.$store.dispatch(GET, {
        url: "role-for-user-create"
      }).then(function (_ref) {
        var data = _ref.data;
        _this.roles = data;
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    createDisplayName: function createDisplayName() {
      var _this = this;

      var firstname = "";

      if (_this.updateUser.first_name) {
        firstname = _this.updateUser.first_name.toLowerCase();
      }

      var lastname = "";

      if (_this.updateUser.last_name) {
        lastname = _this.updateUser.last_name.toLowerCase();
      }

      return firstname + lastname;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this2;
                _context.prev = 1;

                if (_this.$refs.userForm.validate()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                _this.formLoading = true;

                if (_this.lodash.isEmpty(_this.updateUser.profile_logo) === false) {
                  _this.updateUser.profile_logo = _this.updateUser.profile_logo.id;
                }

                _this.$store.dispatch(POST, {
                  url: "user",
                  data: _this.updateUser
                }).then(function () {
                  _this.$router.push(_this.getDefaultRoute("user", {
                    query: {
                      status: "active"
                    }
                  }));
                }).catch(function (error) {
                  _this.logError(error);
                }).finally(function () {
                  _this.formLoading = false;
                });

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                ErrorEventBus.$emit("update:error", InitializeError(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.getRoles();
    this.$store.dispatch(SET_BREADCRUMB, [{
      title: "User",
      route: "user"
    }, {
      title: "Create"
    }]);
  },
  computed: {
    getProfileImage: function getProfileImage() {
      return this.lodash.isEmpty(this.updateUser.profile_logo) === false ? this.updateUser.profile_logo.file.url : null;
    }
  } // beforeRouteLeave(to, from, next) {
  //   const _this = this;
  //   _this.routePreventDialog = true;
  //   PreventDialogEventBus.$on("stay-on-page", function () {
  //     _this.routePreventDialog = false;
  //     next(false);
  //   });
  //   PreventDialogEventBus.$on("leave-page", function () {
  //     _this.routePreventDialog = false;
  //     next();
  //   });
  // },

};